import React from "react"
// import { Link } from "gatsby"
// import Row from "react-bootstrap/Row"
// import Col from "react-bootstrap/Col"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Banner from "../components/banner"
import Section from "../components/section"
import Paragraph from "../components/paragraph"
import "../components/tab-container.css"

import bannerPng from "../images/about/banner.png"
import honorPng from "../images/about/honor.png"
import organizationPng from "../images/about/organization.png"

import './about.css';

const Page = () => (
  <Layout>
    <SEO title="关于我们" />
    <Banner image={bannerPng} />
    <Section>
      <div style={{ paddingTop: 30 }}>
        <div className="content-wrapper" style={{ paddingBottom: 20 }}>
          <div className="content-header">
            <h3>公司介绍</h3>
          </div>
          <div className="content-main">
            <Paragraph>
              北京海华鑫安生物信息技术有限责任公司（简称：海华鑫安）于2011年在北京市丰台区科技园注册成立，公司立足于生物技术与信息技术，为客户提供各类整体解决方案。主要致力于实验室的“四化"业务服务，即信息化、自动化、专业化、标准化。
            </Paragraph>
            <Paragraph>
              海华鑫安成立至今已在技术层面突飞猛进，获得国家及中关村高新技术企业证书、国家版权局颁发的多项产品著作权证书，公司多次获得省部级科学进步奖。
            </Paragraph>
            <Paragraph>
              海华鑫安将伴随着中国生物信息技术产业快速发展的步伐，依靠自身的优势和兄弟企业的合作力量异军突起，在行业内已呈腾飞之势，我们借助生物科技产业朝阳发展的大好时机，奋发图强，致力于研发优质的产品，树立良好的品牌形象，为客户提供优质的服务。
            </Paragraph>
            <Paragraph>
              海华鑫安将期待着与您合作，共同迈向美好的明天
            </Paragraph>
          </div>
        </div>
        <div className="content-wrapper" style={{ paddingBottom: 20 }}>
          <div className="content-header">
            <h3>荣誉资质</h3>
          </div>
          <div className="content-main">
            <img src={honorPng} alt="荣誉资质" />
          </div>
        </div>
        <div className="content-wrapper">
          <div className="content-header">
            <h3>组织架构</h3>
          </div>
          <div className="content-main">
            <img src={organizationPng} alt="组织架构" />
          </div>
        </div>
      </div>
    </Section>
  </Layout>
)

export default Page
